import React, { Component } from 'react'

import { connect } from 'react-redux'
import * as api from '../../api/api'
import * as actions from '../../actions'

import { Link } from 'react-router-dom'

import {TextField} from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';

import { Button, ButtonIcon } from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Grid, GridCell } from 'rmwc/Grid';
import {
  Dialog,
  DefaultDialogTemplate,
  DialogSurface,
  DialogHeader,
  DialogHeaderTitle,
  DialogBody,
  DialogFooter,
  DialogFooterButton,
  DialogBackdrop
} from 'rmwc/Dialog';

import StatusMessage from '../../util/StatusMessage'


class RegistrationFees extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: '',
      message: '',
      errorMsg: '',
      open: false,
      selectedFee: {
        id: '',
        amount:'',         
      },
      data: {
        certification: 'tpo',
        fees :[]
      }
    }
    
  }


  componentDidMount() {
    
    let data = Object.assign({}, this.state.data)

    api.getAdminRegistrationFeeDetails(this.props.user.accessToken, data.certification).then((result) => {
          console.log(result)
          const { status, errors} = result
          if (status === 'error') {
            this.setState({ errorMsg: 'Error in Fetching Detail' })  
          }
          if (status === 'success') {
    
            data.fees = result.data
            this.setState({data:data})
          }
        })
        .catch((err) => {
          this.setState({ errorMsg: 'Error in Fetching Details' })
        })
    
  }


  handleFeeUpdate = (e, selectedFeeParam) => {
    e.preventDefault()
    let selectedFee = Object.assign({}, this.state.selectedFee)
    selectedFee.id = selectedFeeParam.id
    selectedFee.amount = selectedFeeParam.amount
    this.setState({selectedFee: selectedFeeParam, open: true, snackbarIsOpen: false})
  }

  handleFeeModify = (e) => {
    e.preventDefault()
    let data = Object.assign({}, this.state.data)
        
    let apiInput = {
      'certification': this.state.data.certification,
      'fee_id': this.state.selectedFee.id,
      'amount': this.state.selectedFee.amount    
    }

    api.adminRegistrationFeeModify(this.props.user.accessToken, apiInput).then((result) => {
        const { status, errors} = result
        if (status === 'error') {
          this.setState({ errorMsg: 'Error in saving Details' })  
        }
        if (status === 'success') {
          data.fees = result.data
          this.setState({data: data, open: false})
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: 'Error in Saving Details' })
      })
  }
    
  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  onInputChange = evt => {
    const selectedFee = Object.assign({}, this.state.selectedFee);
    selectedFee[evt.target.name] = evt.target.value;
    this.setState({selectedFee});
  };

  render() {
    const { open } = this.state;
    const {registeredUser} = this.state;
     let FeeListComponent
     let handleFeeUpdate = this.handleFeeUpdate
     let openModal = this.openModal
     if(this.state.data.fees.length >0){
      console.log(this.state.data.fees)
      FeeListComponent = 
        ( <tbody>
            {this.state.data.fees.map(fee => (

              <tr>
                <td>{fee.id}</td>
                <td>{fee.amount}</td>
                <td>{fee.currencyName}</td>                
                <td><Button onClick={((e) => handleFeeUpdate(e, fee))}>Update</Button></td>
              </tr>
            ))}
          </tbody>  
        )

     }

  
     let notiticaionModal=(
      <Dialog
        open={open}
         onClose={evt => this.setState({standardDialogOpen: false})}
      >
        <DialogSurface>
        <DialogHeader>
          <DialogHeaderTitle>Fee Update</DialogHeaderTitle>
        </DialogHeader>
        <DialogBody>
          <TextField 
            label="Fee Id" 
            autoComplete="off" 
            disabled
            name="feeid" 
            value={this.state.selectedFee.id} 
            
          />
          <br/>
          <TextField 
            label="currency"
            disabled 
            autoComplete="off" 
            name="cuurency" 
            value={this.state.selectedFee.currencyName} 
            
          />
          <br/>
          <TextField 
            label="Amount" 
            autoComplete="off" 
            name="amount" 
            value={this.state.selectedFee.amount} 
            onChange={this.onInputChange}
          />

        </DialogBody>
        <DialogFooter>
            <StatusMessage error_msg = {this.state.errorMsg}/>
            <DialogFooterButton cancel>Cancel</DialogFooterButton>
            <DialogFooterButton onClick={((e) => this.handleFeeModify(e))}>Modify</DialogFooterButton>
        </DialogFooter>
        </DialogSurface>
        <DialogBackdrop />  
      </Dialog>
    )


      return (
        <Grid>
          <GridCell span="12">
            <div>TPO Registration Fee - Admin</div>
            <div className="opportunity-top-bar">
              
              
            </div>

            <div>
              <table className="admin-table">
                <th>Feed Id</th>
                <th>Amount</th>
                <th>Currency</th>
                {FeeListComponent}
              </table>
            </div>
            {notiticaionModal}
            
          </GridCell>
        </Grid>
      )
    
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationFees);


// WEBPACK FOOTER //
// ./src/views/admin/RegistrationFees.jsx